import { TemporaryStopRequest } from '@/utils/type';
import { cancellableRequest, request } from '../core';
import { Method } from '../core/util';
import { RemoteCommandType } from '@/utils/constant';

class BussinessApi {
  /**
   * 获取视频播放地址
   * @param vehicleName 车号
   * @return {Promise}
   */
  public fetchVideoPlayUrl = (vehicleName: string) => {
    return cancellableRequest({
      path: '/monitor/web/video/url',
      method: Method.POST,
      body: { vehicleName },
    });
  };

  public getVehicleList = async (params: {
    cockpitNumber: string;
    pageSize: number;
    pageNum: number;
  }) => {
    return request({
      path: '/monitor/web/cockpit/getVehicleList',
      method: Method.POST,
      body: params,
    });
  };

  public getVideoUrlList = async (vehicleNameList: string[]) => {
    const params: RequestOptions = {
      path: '/monitor/web/video/url/getVideoUrlList',
      method: Method.POST,
      body: {
        vehicleNameList: vehicleNameList,
      },
    };
    return request(params);
  };
  public temporaryStop = async (params: TemporaryStopRequest) => {
    const requestOptions: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/command/temporaryStop',
      body: params,
    };
    return request(requestOptions);
  };
  public vehicleRecovery = async (params: {
    vehicleName: string;
    timeStamp: string | number;
  }) => {
    const requestOptions: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/command/recovery',
      body: params,
    };
    return request(requestOptions);
  };
  public reportManualAlarm = async (params: {
    vehicleName: string;
    remark: string;
  }) => {
    const requestOptions: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/alarm/reportManualAlarm',
      body: params,
    };
    return request(requestOptions);
  };

  public searchVehicleList = (params: {
    searchName: string;
    cockpitNumber: string;
  }) => {
    const requestOptions: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/cockpit/searchVehicleList',
      body: params,
    };
    return request(requestOptions);
  };
  /**
   * 座席看板列表
   * @param cockpitTeamNumber 座席团队编号
   * @return {Promise}
   */
  public getCockpitIssueStatistic = (
    cockpitTeamNumber: string
  ): Promise<any> => {
    return request({
      path: '/monitor/web/cockpitTeam/getCockpitIssueStatistic',
      method: Method.POST,
      body: {
        cockpitTeamNumber,
      },
    });
  };

  public buttonCommand = async (params: {
    cockpitNumber: string;
    vehicleName: string;
    cockpitUserName: string;
    remoteCommandType: RemoteCommandType;
  }) => {
    return request({
      path: '/monitor/web/drive/command/send/buttonCommand',
      method: Method.POST,
      body: params,
    });
  };
}

export default BussinessApi;
